import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type SelectionProps, Selection } from '../Selection';

type FormSelectionProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  SelectionProps;

function FormSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormSelectionProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <Selection
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText ?? null}
      required={props?.required ?? !!props.rules?.required}
      inputRef={ref}
    />
  );
}

export type { FormSelectionProps };
export { FormSelection };
